<script>
import { useAlert } from 'dashboard/composables';
import CannedResponseForm from './CannedResponseForm.vue';

const toFormFile = file => ({
  blobId: file.blob_id,
  url: file.url,
  filename: file.filename,
  contentType: file.content_type,
  byteSize: file.byte_size,
});

export default {
  name: 'EditCanned',
  components: { CannedResponseForm },
  props: {
    id: { type: Number, default: null },
    edcontent: { type: String, default: '' },
    edshortCode: { type: String, default: '' },
    edcategory: { type: String, default: '' },
    edattachments: { type: Array, default: () => [] },
    edbuttonLabel: { type: String, default: '' },
    edbuttonReplyContent: { type: String, default: '' },
    edbuttonAttachments: { type: Array, default: () => [] },
    onClose: { type: Function, default: () => {} },
  },
  data() {
    return {
      isLoading: false,
      initial: {
        shortCode: this.edshortCode,
        content: this.edcontent,
        category: this.edcategory || '',
        attachments: (this.edattachments || []).map(toFormFile),
        buttonLabel: this.edbuttonLabel || '',
        buttonReplyContent: this.edbuttonReplyContent || '',
        buttonAttachments: (this.edbuttonAttachments || []).map(toFormFile),
      },
      originalBlobIds: (this.edattachments || []).map(file => file.blob_id),
      originalButtonBlobIds: (this.edbuttonAttachments || []).map(
        file => file.blob_id
      ),
    };
  },
  methods: {
    editCannedResponse(form) {
      this.isLoading = true;
      this.$store
        .dispatch('updateCannedResponse', {
          id: this.id,
          short_code: form.shortCode,
          content: form.content,
          category: form.category,
          blob_ids: form.attachments
            .filter(file => file.blobSignedId)
            .map(file => file.blobSignedId),
          remove_blob_ids: this.originalBlobIds.filter(
            blobId => !form.attachments.some(file => file.blobId === blobId)
          ),
          button_label: form.buttonLabel || null,
          button_reply_content: form.buttonReplyContent || null,
          button_blob_ids: form.buttonAttachments
            .filter(file => file.blobSignedId)
            .map(file => file.blobSignedId),
          remove_button_blob_ids: this.originalButtonBlobIds.filter(
            blobId =>
              !form.buttonAttachments.some(file => file.blobId === blobId)
          ),
        })
        .then(() => {
          this.isLoading = false;
          useAlert(this.$t('CANNED_MGMT.EDIT.API.SUCCESS_MESSAGE'));
          setTimeout(() => {
            this.onClose();
          }, 10);
        })
        .catch(error => {
          this.isLoading = false;
          const errorMessage =
            error?.message || this.$t('CANNED_MGMT.EDIT.API.ERROR_MESSAGE');
          useAlert(errorMessage);
        });
    },
  },
};
</script>

<template>
  <CannedResponseForm
    mode="edit"
    :initial="initial"
    :exclude-id="id"
    :is-loading="isLoading"
    @submit="editCannedResponse"
    @cancel="onClose"
  />
</template>
